import { ChangeEventHandler, Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { getLanguageDirection, onlyNum, stringToId } from '../../../lib/funcs';
import FormGroup from '../FormGroup';
import InnerPriceUpdater from './InnerPriceUpdater';
import { useLanguage } from '../../../lib/LanguageContext';

interface IPriceInput {
  price: string | number,
  setPrice: Dispatch<SetStateAction<number|string>>,
  priceInstrument: IInstrument|undefined;
  className?: string;
  setInstruments: React.Dispatch<React.SetStateAction<IInstrument[]>>;
  setSelectedInstrument: React.Dispatch<React.SetStateAction<IInstrument | undefined>>;
  setDepositCurrencies: (depositCurrencies:IDepositCurrency[]) => void;
  setSelectedDepositCurrency: React.Dispatch<React.SetStateAction<IDepositCurrency | undefined>>;
}

function PriceInput({ price, setPrice, priceInstrument, className, setDepositCurrencies, setInstruments, setSelectedDepositCurrency, setSelectedInstrument}: IPriceInput) {
  const priceChanged: ChangeEventHandler<HTMLInputElement> = (e) => {
    setPrice(onlyNum(e.target.value));
  }

  const { languageData } = useLanguage();

  return priceInstrument && priceInstrument.DisplaySymbolName ? (
      <div className={[getLanguageDirection(languageData) === "rtl" ? "text-align-right ltr" : "", className || "col-12"].join(" ")}>
        <FormGroup label={(priceInstrument.DisplaySymbolName) + ' ' + languageData.price}>
          <input type="text" id={stringToId(`${priceInstrument.DisplaySymbolName} price`)} value={price} onChange={priceChanged} />
          <InnerPriceUpdater setSelectedInstrument={setSelectedInstrument} setInstruments={setInstruments} setDepositCurrencies={setDepositCurrencies} setSelectedDepositCurrency={setSelectedDepositCurrency} />
        </FormGroup>
      </div>
    ) : <></>;
}

export default PriceInput;
